export function courseEnroll(name) {
  const wpnonce = window?.dataW?.config?.wpnonce;

  const wpNonceParam = wpnonce ? `&_wpnonce=${wpnonce}` : '';

  return fetch(
    `${window.dataWP.config.endpoints.home_url}/wp-json/pokercoaching/v1/course_enroll?post_name=${name}${wpNonceParam}`,
    {
      method: 'POST',
    }
  )
    .then((res) => {
      if (!res.ok) {
        throw Error('Response error');
      }
      return res.json();
    })
    .then((res) => res);
}
